/**
 * Enum representing member roles within the company.
 *
 * @enum {string}
 * @note ETT-133 Order of roles is important for their priorities match.
 */
export enum CompanyMemberRole {
	owner = 'owner',
	admin = 'admin',
	editor = 'editor',
	viewer = 'viewer'
}

/**
 * Enum representing the status of the company member request.
 *
 * @enum {string}
 */
export enum CompanyMemberRequestStatus {
	inProgress = 'in_progress',
	reSent = 're_sent',
	accepted = 'accepted',
	declined = 'declined',
	deactivate = 'deactivate' // ETT-424 Special status to keep enum commands clear and not use string.
}

/**
 * Enum representing the type of company.
 *
 * @enum {string}
 */
export enum CompanyType {
	all = 'all',
	customer = 'customer',
	agent = 'agent',
	talent = 'talent'
}
